// document.querySelector('.site-header-cart--button').addEventListener('click',(e)=>{
//   e.preventDefault();
//   document.querySelector('ajax-cart').open();
// })

class AjaxCart extends HTMLElement {
  constructor() {
    super();
    this.initClickEvents();
    
  }

  initClickEvents() {
    this.previousElementSibling.addEventListener('click', this.close);
    this.querySelector('ajaxcart-header button').addEventListener('click', this.close);
     // Add to cart button in cart
    let AddBtn = document.querySelectorAll(".addcart-button");
    AddBtn.forEach((el) => {
      el.addEventListener("click", function (event) {
        event.preventDefault();
        this.closest('ajax-cart').addToCart(this.getAttribute("variant_id"));
      });
    });
  }

  addToCart(Id) {
    let formData = {
      items: [
        {
          id: Id,
          quantity: 1,
        },
      ],
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        this.open();
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  
  open(refresh = true){
    document.body.classList.add('overflow-hidden');
    this.closest('.ajax-cart').classList.add('is--open');

    // Refresh cart only if required
    if(refresh) this.refreshCart();
  }

  close(){
    document.body.classList.remove('overflow-hidden');
    this.closest('.ajax-cart').classList.remove('is--open');
  }

  refreshCart(cartElement = false) {
    if(!cartElement){
      fetch("/cart?view=ajaxcart")
      .then((response) => response.text())
      .then((responseText) => {
        this.replaceCart(responseText);
      });
    } else {
      this.replaceCart(cartElement);
    }
  }

  replaceCart(cartElement){
    const html = new DOMParser().parseFromString(cartElement, 'text/html');
    const source = html.querySelector('.ajax-cart');
    const destination = this.closest('.ajax-cart');
    if (source && destination) destination.innerHTML = source.innerHTML;
    this.getCount()
  }

  getCount() {
  const count = document.querySelector('.number-item');
  const intCount = document.querySelector('.main-class-cart-countt');

  let getCount = 0;

  if (intCount) {
    getCount = intCount.innerText;
  }

  count.innerHTML = getCount;
}
}
customElements.define('ajax-cart', AjaxCart);


class AjaxcartItem extends HTMLElement {
  constructor() {
    super();
    this.quantityInput = this.querySelector('quantity-input input');
    this.quantityButtons = this.querySelectorAll('quantity-input button');
    this.removeButton = this.querySelector('cart-remove-button');
    this.ajaxCartElement = this.closest('ajax-cart');
    this.quantityInput?.addEventListener("change", this.onQuantityChange.bind(this));
    this.quantityButtons.forEach(btn=>btn.addEventListener("click", this.onQuantityBtnClick.bind(this)));
    this.removeButton?.addEventListener("click", this.onRemoveItem.bind(this));
  }
  
  onQuantityBtnClick(e) {
    e.preventDefault();
    let event = new Event('change');
    const quantity = parseInt(this.quantityInput.value);
    if(e.currentTarget.name == 'plus'){
      this.quantityInput.value = quantity + 1;
    } else if(quantity > 0){
      this.quantityInput.value = quantity - 1;
    }
    this.quantityInput.dispatchEvent(event);
  }
  
  onRemoveItem(e) {
    e.preventDefault();

    let event = new Event('change');
    this.quantityInput.value = 0;
    this.quantityInput.dispatchEvent(event);
  }
  
  onQuantityChange() {
    // TODO: Check For max quantity reached
    // TODO: Initialize loading so customer does't increase quantity faster than ajax call can be made.
    const quantity = this.quantityInput.value;
    const itemKey = this.dataset['itemKey'];

    // Make config for fetch
    const config = {};
    config.headers = {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.method = 'POST';

    // Make data to submit
    const formData = new FormData();
    formData.append('id',itemKey);
    formData.append('quantity',quantity);
    formData.append('sections','ajaxcart');
    formData.append('sections_url',"/cart?view=ajaxcart");

    config.body = formData;

    fetch(`/cart/change.js`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      
      this.ajaxCartElement.refreshCart(response?.sections['ajaxcart']);
      document.querySelector('.site-header-cart--count').setAttribute('data-header-cart-count',response.item_count);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      // TODO: Hide Loading
    });
  }

  handleErrorMessage(errorMessage = false) {
    // TODO: Handle Error Message
  }

}
customElements.define('ajaxcart-item', AjaxcartItem);
